export default __webpack_public_path__ + "static/media/Belt of the Ragereaver.e2371f56.jpg";